/**
 * Sort deals array by the given sort key.
 * Returns a new array (does not mutate).
 * @param {import('../data/deals').Deal[]} deals
 * @param {'trending'|'discount'|'price_low'|'price_high'} sortKey
 * @returns {import('../data/deals').Deal[]}
 */
export const sortDeals = (deals, sortKey) => {
  const copy = [...deals]
  switch (sortKey) {
    case 'discount':
      return copy.sort((a, b) => (((b.originalPrice - b.discountedPrice)/b.originalPrice)*100) - ((a.originalPrice - a.discountedPrice)/a.originalPrice)*100)
    case 'price_low':
      return copy.sort((a, b) => a.discountedPrice - b.discountedPrice)
    case 'price_high':
      return copy.sort((a, b) => b.discountedPrice - a.discountedPrice)
    case 'trending':
    default:
      return copy.sort((a, b) => (b.trending ? 1 : 0) - (a.trending ? 1 : 0))
  }
}
